/* unplugin-vue-components disabled */import script from "./publish.vue?vue&type=script&setup=true&lang=js"
export * from "./publish.vue?vue&type=script&setup=true&lang=js"

import "./publish.vue?vue&type=style&index=0&id=e3c0184e&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3c0184e"]])

export default __exports__